import { useEffect, useState } from 'react';
import axios from 'axios';

import { API_BASE as API } from '@/config/api';
import { RECORRIDOS, RECORRIDOS_ACTIVOS } from '@/data/recorridos/config';

function normalizeTrayectosPayload(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.trayectos)) return data.trayectos;
  return [];
}

function withActivoApiFlag(r, api) {
  const row = api.find((t) => t.id === r.id);
  const activoApi = row ? row.activo !== false : true;
  return { ...r, activoApi };
}

function fallbackCatalogo() {
  return RECORRIDOS.map((r) => ({ ...r, activoApi: true }));
}

function fallbackSoloActivosEstaticos() {
  return RECORRIDOS_ACTIVOS.map((r) => ({ ...r, activoApi: true }));
}

/**
 * Catálogo GET /api/trayectos (admin activa/desactiva tramos).
 * - `recorridos`: todos los recorridos con `activoApi` (landing: mostrar inactivos deshabilitados).
 * - `recorridosActivos`: solo activos (chips en paradero).
 * Si la API falla, se asume todo activo según catálogo estático.
 * Reintenta al volver a la pestaña y cada ~45s.
 */
export function useRecorridosVisibles() {
  const [recorridos, setRecorridos] = useState(fallbackCatalogo);
  const [recorridosActivos, setRecorridosActivos] = useState(fallbackSoloActivosEstaticos);
  /** Respuesta cruda de GET /api/trayectos; null si falló la red (no forzar overlay). */
  const [trayectosFromApi, setTrayectosFromApi] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancel = false;

    const load = () => {
      axios
        .get(`${API}/trayectos`, { params: { _t: Date.now() } })
        .then((res) => {
          if (cancel) return;
          const api = normalizeTrayectosPayload(res.data);
          setTrayectosFromApi(api);
          const full = RECORRIDOS.map((r) => withActivoApiFlag(r, api));
          setRecorridos(full);
          setRecorridosActivos(full.filter((x) => x.activoApi));
          setReady(true);
        })
        .catch(() => {
          if (!cancel) {
            setTrayectosFromApi(null);
            setRecorridos(fallbackCatalogo());
            setRecorridosActivos(fallbackSoloActivosEstaticos());
            setReady(true);
          }
        });
    };

    load();

    const intervalMs = 45000;
    const id = window.setInterval(load, intervalMs);
    const onVisibility = () => {
      if (document.visibilityState === 'visible') load();
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      cancel = true;
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  return { recorridos, recorridosActivos, ready, trayectosFromApi };
}
